import { useMediaQuery } from "@mui/material";

const useBreakpoints = () => {
  const isXlUp = useMediaQuery((theme) => theme.breakpoints.up("xl"));
  const isLgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const isMdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isSmUp = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const isXsUp = useMediaQuery((theme) => theme.breakpoints.up("xs"));

  return {
    isXlUp,
    isLgUp,
    isMdUp,
    isSmUp,
    isXsUp,
  };
};

export { useBreakpoints };
